import { Injectable } from '@angular/core';
import { Router, NavigationEnd, Event } from '@angular/router';
import { filter } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class PreviousRouteService {
  private previousUrl: any;
  private currentUrl: any;

  constructor(private router: Router) {
    this.currentUrl = this.router.url;

    this.router.events
      .pipe(
        filter(
          (event: Event): event is NavigationEnd =>
            event instanceof NavigationEnd
        )
      )
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.urlAfterRedirects;

        if (this.previousUrl) {
          localStorage.setItem('previousUrl', this.previousUrl);
        }
      });
  }

  public getPreviousUrl(): string | null {
    if (this.previousUrl) {
      return this.previousUrl;
    }
    return localStorage.getItem('previousUrl');
  }
}
